import { createStyles, Theme } from '@material-ui/core/styles';

import { getColourStyles, getCommonStyles } from '@shared/components/select-new/Select.styles';
import { colors } from '@shared/theme/colours';
import { ButtonSize, NewButtonColour } from '@shared/types/common/button';

export function styles(theme: Theme) {
  const commonStyles = getCommonStyles(theme);

  return createStyles({
    // ---- Override common styles ----

    ...commonStyles,
    root: {
      ...commonStyles.root,

      // Colours
      ...getColourStyles(theme, NewButtonColour.Danger, 'currentColor'),
      ...getColourStyles(theme, NewButtonColour.Ghost, '#7E8899'),
      ...getColourStyles(theme, NewButtonColour.Outline, '#7E8899'),
      ...getColourStyles(theme, NewButtonColour.PrimaryNavy, 'currentColor'),
      ...getColourStyles(theme, NewButtonColour.PrimaryLilac, 'currentColor'),
      ...getColourStyles(theme, NewButtonColour.PrimarySalmon, 'currentColor'),
      ...getColourStyles(theme, NewButtonColour.PrimaryTeal, 'currentColor'),
      ...getColourStyles(theme, NewButtonColour.Subtle, '#7E8899'),
      ...getColourStyles(theme, NewButtonColour.Success, 'currentColor'),
      ...getColourStyles(theme, NewButtonColour.Transparent, 'currentColor'),
    },

    // ---- Component styles ----

    divider: {
      borderTop: `1px solid ${colors.grey.lightest}`,
      margin: theme.spacing(1.5, 0),
    },
    label: {
      display: 'flex',
      fontSize: 14,
      lineHeight: 20,
      fontWeight: 500,
      width: '100%',
      // Size
      ['&$' + ButtonSize.extraSmall]: {
        fontSize: 12,
      },
      ['&$' + ButtonSize.small]: {
        fontSize: 14,
      },
      ['&$' + ButtonSize.mediumLegacy]: {
        fontSize: 14,
      },
      ['&$' + ButtonSize.medium]: {
        fontSize: 14,
      },
      ['&$' + ButtonSize.large]: {
        fontSize: 16,
      },
    },
    labelIcon: {
      alignItems: 'center',
      display: 'inline-flex',
      fontSize: 16,
      paddingRight: theme.spacing(2),
      '& svg': {
        color: 'currentColor',
        fontSize: 'inherit',
      },
      '& svg path': {
        stroke: 'currentColor',
      },
      '& i': {
        color: 'currentColor',
        fontSize: 'inherit',
      },
    },
    menuItemLinkWrapper: {
      ...commonStyles.menuItem,
      padding: 0,
    },
    menuItemLink: {
      width: '100%',
      padding: theme.spacing(2.5, 3.75),
    },

    // Utility classes - DO NOT STYLE
    menuItemActive: {},
    menuItemHovered: {},
  });
}
